import useSWR, { useSWRConfig } from "swr";
import _ from "lodash";
import { useEffect, useMemo } from "react";
import { serialize } from "swr/_internal";
function useUncachedSWR(key, fetcher, config?) {
  const { cache } = useSWRConfig();
  const { data, error, isLoading, mutate } = useSWR(key, fetcher, config);
  const serialKey = useMemo(() => {
    const [_key] = serialize(key);
    return _key;
  }, [key]);
  //const oldKeyRef = useRef();

  useEffect(() => {
    // console.log("oldKeyRef?.current ", oldKeyRef?.current, key);
    // if (!_.isEqual(oldKeyRef?.current, key)) {
    //   cache.delete(oldKeyRef?.current);
    // }
    // oldKeyRef.current = key;
    return () => {
      cache.delete(serialKey);
    };
  }, [serialKey]); // Only re-run if value changes
  return { data: data, error, isLoading, mutate };
}

export default useUncachedSWR;
